import { useNavigate } from 'react-router-dom'

import { useCurrentStoreId } from '@hooks/useCurrentStore'
import { useScan } from '@hooks/useScan.ts'
import { useDayLink } from '@hooks/useSelectedDay'
import { routesFactory } from '@utils/routes.ts'

function useNavigator() {
  const navigate = useNavigate()
  const storeId = useCurrentStoreId()
  const { pathParam: scanId } = useScan()
  const dayLink = useDayLink()

  function goToStoreMap(gtin: string, withTasks = false) {
    const url = routesFactory.storeMapByGtin(storeId, scanId, gtin, withTasks)
    // a todo opens on the latest day, like the list it comes from
    navigate(withTasks ? url : dayLink(url))
  }

  function gotoProductFinder() {
    navigate(dayLink(routesFactory.productFinder(storeId, scanId)))
  }

  return {
    goToStoreMap,
    gotoProductFinder,
  }
}

export default useNavigator